const houseTypeListObject = payload => {
  return {
    type: "houseTypeList",
    payload
  };
};

export default houseTypeListObject;
